import { render, staticRenderFns } from "./PopoverSavePreset.vue?vue&type=template&id=16441b0e"
import script from "./PopoverSavePreset.vue?vue&type=script&lang=js"
export * from "./PopoverSavePreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports